import React, { useState } from 'react';
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle,
    DocumentCardActivity} from '@fluentui/react';
import {ApproverDialog} from "./ApproverDialog";
import Api from '../../services/Api';
import { TaskApproverDialog } from "./TaskApproverDialog";
import { renderDateTime } from '../../helpers/HelperMethods';

const RequestLicenseTask = ({task, refresh, showDialog}) => {
    const [closeDialog, setCloseDialog] = useState(false);

    const _mapOwnerForPeople = (user) => {
        return [{
            name: user.displayName
        }];
    }

    const closeApproverDialog = () => {
        setCloseDialog(true);
    }

    const _mapTypeToText = (licenseType) => {
        switch(licenseType) {
            case 0:
                return 'Per App';
            default:
                return licenseType;
        }
    }

    const postDecision = (object, urlPart) =>
    {
        const post = {
            id: task.id,
            comment: object.comment,
            costCenter: object.costCenter,
            powerAppId: task.powerAppId,
            status: 'Approved'
        };

        Api.post(urlPart, post)
            .then(res => res.data)
            .then(post => {
                    if (post === 200) {
                        refresh();
                    } else {
                        console.log("Update failed")
                    }
                }
            ).catch((error) => {
            console.log(error)})
    }

    const onRejectDecision = (comment) =>
    {
        const url = '/RejectRequestLicense'
        postDecision(comment, url);
        refresh();
    }

    const onApproveDecision = (object) => 
    {
        const url = '/ApproveRequestLicense';
        postDecision(object, url);
        refresh();
    }

    const licenseTask = <div>
                    <DocumentCard styles={cardStyles}>
                        <DocumentCardDetails styles={detailsStyles}>
                            <div style={titleStyles}>
                                <DocumentCardTitle styles={{ root: {color: 'white' }}} title={"License request"} shouldTruncate={false} />
                            </div>
                            <div style={statusStyles}><b>Power App name: </b>{task.powerApp.name}</div>
                            <div style={statusStyles}><b>Environment: </b>{task.powerApp.environment.name}</div>
                            <div style={statusStyles}><b>Number of licenses requested: </b>{task.licensesAmountRequested}</div>
                            <div style={statusStyles}><b>Requested license type: </b>{_mapTypeToText(task.licenseType)}</div>
                            <div style={statusStyles}><b>Current number of Per App licenses assigned: </b>{task.powerApp.licensesAssigned}</div>
                            <div style={statusStyles}><b>Cost Center: </b>{task.costCenter}</div>
                            <div style={statusStyles}><b>Business Justification: </b>{task.businessJustification}</div>
                            <div style={createdByStyles}>Requested by: </div>
                        </DocumentCardDetails>
                        <DocumentCardActivity
                                activity={`Created on ${renderDateTime(task.created)}`}
                                people={_mapOwnerForPeople(task.createdBy)}
                            />
                                <ApproverDialog buttonName="Decision"
                                                title="Approve or reject license request"
                                                onReject={onRejectDecision.bind(this)}
                                                onApprove={onApproveDecision.bind(this)}
                                                reason={task.businessJustification}
                                                costCenter={task.costCenter}
                                />
                    </DocumentCard>
                </div>

    return(
        <div>
            {   
                (!closeDialog && showDialog) && <TaskApproverDialog 
                                    task = {licenseTask}
                                    closeDialog = {closeApproverDialog}
                                    title = {'PowerApp license request'}
                                />
            }
            {
                !showDialog && licenseTask
            }
        </div>
    )
}

const statusStyles = {
    paddingLeft: '10px',
    paddingRight: '10px',
    fontSize: '13px'
}

const createdByStyles = {
    paddingLeft: '10px',
    fontSize: '12px'
}

// const btnEditStyles = {
//     root: {
//         width: '100%',
//         backgroundColor: '#742774',
//         border: 'none'
//     },
//     rootHovered: {
//         backgroundColor: '#742774',
//         border: 'none'
//     },
//     rootPressed: {
//         backgroundColor: '#742774',
//         border: 'none'
//     },

//     backgroundColor: '#742774',
//     border: 'none',
// }

const titleStyles = {
    maxHeight: '40px',
    backgroundColor: '#742774',
}

const cardStyles = {
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height: 300,
        border: '1px solid grey',
    }
};

const detailsStyles = {
    root: {
        height: 220,
        justifyContent: 'space-between'
    }
}

export default RequestLicenseTask;


// WEBPACK FOOTER //
// ./src/components/ManageCenter/RequestLicenseTask.js